<template>
    <sui-segment :loading="isLoading">
        <sui-dimmer active inverted v-if="isLoading">
            <sui-loader />
        </sui-dimmer>
        <sui-form @submit="onSaveWorkshopSchedule">

        <div class="segment-header">
            <sui-header size="huge">{{ $t('workshopSchedule.form.title') }}</sui-header>
            <sui-button :content="$t('common.save')" color="violet" :loading="isSaving" :disabled="isSaving"/>
        </div>

            <sui-header>{{ $t('workshopSchedule.form.generalInformations') }}</sui-header>
            <sui-form-fields fields="three">
                <sui-form-field>
                    <label>{{ $t('workshopSchedule.form.customerName') }}</label>
                    <input
                        disabled
                        type="text"
                        :value="customer.name"
                    >
                </sui-form-field>

                <sui-form-field>
                    <label>{{ $t('workshopSchedule.form.type') }}</label>
                    <sui-dropdown
                        :placeholder="$t('workshopSchedule.form.type')"
                        selection
                        :disabled="isEdit"
                        :options="typeOptions"
                        @input="onTypeChange"
                        v-model="workshopSchedule.type"
                    />
                </sui-form-field>

                <sui-form-field>
                    <label>{{ $t('workshopSchedule.form.inputFile') }}</label>
                    <div class="ui action input">
                        <sui-dropdown
                            :placeholder="$t('workshopSchedule.form.inputFile')"
                            selection
                            class="fluid"
                            :options="inputFileOptions"
                            v-model="workshopSchedule.input_file_id"
                            @input="onInputFileChange"
                            :disabled="!workshopSchedule.type || isEdit"
                        />
                        <sui-button
                            type="button"
                            :disabled="isEditingInputFile || !workshopSchedule.type"
                            v-on:click="handleInputFileModalState(true)"
                        >
                            {{ $t('workshopSchedule.form.inputFileConfig') }}
                        </sui-button>
                    </div>
                </sui-form-field>
            </sui-form-fields>

            <sui-form-fields fields="two">
                <sui-form-field>
                    <label>{{ $t('workshopSchedule.form.name') }}</label>
                    <input
                        type="text"
                        v-model="workshopSchedule.name"
                    >
                </sui-form-field>

                <sui-form-field>
                    <label>{{ $t('workshopSchedule.form.template') }}</label>
                    <sui-dropdown
                        :placeholder="$t('workshopSchedule.form.template')"
                        selection
                        :options="templateOptions"
                        v-model="workshopSchedule.template_id"
                    />
                </sui-form-field>
            </sui-form-fields>

            <div v-if="workshopSchedule.type === 'ICAR'">
                <sui-divider></sui-divider>
                <sui-header>{{ $t('workshopSchedule.form.icarFiltersTitle') }}</sui-header>

                <sui-table class="compact" celled striped>
                    <sui-table-header>
                        <sui-table-row>
                            <sui-table-header-cell :width="3">{{ $t('workshopSchedule.form.company_code') }}</sui-table-header-cell>
                            <sui-table-header-cell :width="3">{{ $t('workshopSchedule.form.workshop_code') }}</sui-table-header-cell>
                            <sui-table-header-cell :width="3">{{ $t('workshopSchedule.form.section_code') }}</sui-table-header-cell>
                            <sui-table-header-cell :width="4">{{ $t('workshopSchedule.form.receiver') }}</sui-table-header-cell>
                            <sui-table-header-cell
                                :width="2"
                                text-align="center"
                                v-if="workshopSchedule.icar_filters.length > 0"
                            >
                                <sui-button color="violet" icon="plus" type="button" v-on:click="addICarFilter"/>
                            </sui-table-header-cell>
                        </sui-table-row>
                    </sui-table-header>

                    <sui-table-body v-if="workshopSchedule.icar_filters.length === 0">
                        <sui-table-row>
                            <sui-table-cell colspan="5" text-align="center">
                                 <sui-button
                                    fluid
                                    :content="$t('workshopSchedule.form.addFilter')"
                                    color="violet"
                                    icon="plus"
                                    type="button"
                                    v-on:click="addICarFilter"
                                />
                            </sui-table-cell>
                        </sui-table-row>
                    </sui-table-body>

                    <sui-table-body>
                        <sui-table-row v-for="filter of workshopSchedule.icar_filters" :key="filter.id">
                            <sui-table-cell>
                                <input type="text" v-model="filter.company_code" placeholder="003">
                            </sui-table-cell>
                            <sui-table-cell>
                                <input type="text" v-model="filter.workshop_code" placeholder="8">
                            </sui-table-cell>
                            <sui-table-cell>
                                <input type="text" v-model="filter.section_code" placeholder="01">
                            </sui-table-cell>
                            <sui-table-cell>
                                <input type="text" v-model="filter.receiver" placeholder="Jean Michel Voiture">
                            </sui-table-cell>
                            <sui-table-cell text-align="center">
                                <sui-button color="red" icon="minus" type="button" v-on:click="removeICarFilter(filter.id)"/>
                            </sui-table-cell>
                        </sui-table-row>
                    </sui-table-body>
                </sui-table>
            </div>
        </sui-form>

        <sui-divider v-if="workshopSchedule.input_file_id"></sui-divider>

        <div v-if="workshopSchedule.input_file_id">
            <sui-header>{{ $t('workshopSchedule.form.outputLines') }}</sui-header>
            <sui-table class="compact" celled striped>
                <sui-table-header>
                    <sui-table-row>
                        <sui-table-header-cell>{{ $t('workshopSchedule.form.customer_civility') }}</sui-table-header-cell>
                        <sui-table-header-cell>{{ $t('workshopSchedule.form.customer_last_name') }}</sui-table-header-cell>
                        <sui-table-header-cell>{{ $t('workshopSchedule.form.customer_first_name') }}</sui-table-header-cell>
                        <sui-table-header-cell>{{ $t('workshopSchedule.form.vehicle_brand') }}</sui-table-header-cell>
                        <sui-table-header-cell>{{ $t('workshopSchedule.form.vehicle_model') }}</sui-table-header-cell>
                        <sui-table-header-cell>{{ $t('workshopSchedule.form.schedule_date') }}</sui-table-header-cell>
                        <sui-table-header-cell>{{ $t('workshopSchedule.form.meeting_type') }}</sui-table-header-cell>
                        <sui-table-header-cell>{{ $t('workshopSchedule.form.is_curtesy_vehicle') }}</sui-table-header-cell>
                        <sui-table-header-cell>{{ $t('workshopSchedule.form.receiver') }}</sui-table-header-cell>
                        <sui-table-header-cell>{{ $t('workshopSchedule.form.company_code') }}</sui-table-header-cell>
                        <sui-table-header-cell>{{ $t('workshopSchedule.form.workshop_code') }}</sui-table-header-cell>
                        <sui-table-header-cell>{{ $t('workshopSchedule.form.section_code') }}</sui-table-header-cell>
                    </sui-table-row>
                </sui-table-header>

                <sui-table-body v-if="outputLines.length === 0">
                    <sui-table-row>
                        <sui-table-cell colspan="12" text-align="center">
                            {{ $t('common.noDataToDisplay') }}
                        </sui-table-cell>
                    </sui-table-row>
                </sui-table-body>

                 <sui-table-body v-else>
                    <sui-table-row v-for="outputLine of outputLines" :key="outputLine.id">
                        <sui-table-cell>{{outputLine.customer_civility}}</sui-table-cell>
                        <sui-table-cell>{{outputLine.customer_last_name}}</sui-table-cell>
                        <sui-table-cell>{{outputLine.customer_first_name}}</sui-table-cell>
                        <sui-table-cell>{{outputLine.vehicle_brancd}}</sui-table-cell>
                        <sui-table-cell>{{outputLine.vehicle_model}}</sui-table-cell>
                        <sui-table-cell>{{outputLine.schedule_date}}</sui-table-cell>
                        <sui-table-cell>{{outputLine.meeting_type}}</sui-table-cell>
                        <sui-table-cell>{{outputLine.is_curtesy_vehicle}}</sui-table-cell>
                        <sui-table-cell>{{outputLine.receiver}}</sui-table-cell>
                        <sui-table-cell>{{outputLine.company_code}}</sui-table-cell>
                        <sui-table-cell>{{outputLine.workshop_code}}</sui-table-cell>
                        <sui-table-cell>{{outputLine.section_code}}</sui-table-cell>
                    </sui-table-row>

                    <sui-table-row>
                        <sui-table-cell colspan="12" text-align="center">
                            <sui-button
                                fluid
                                color="violet"
                                icon="plus"
                                :content="$t('workshopSchedule.form.nextLines')"
                                type="button"
                                :disabled="!canLoadMoreLines"
                                v-on:click="getOutputLines()"
                            />
                        </sui-table-cell>
                    </sui-table-row>
                </sui-table-body>
            </sui-table>
        </div>

        <sui-segment v-if="isEdit">
            <sui-header>Actions</sui-header>
            <sui-button color="red" content="Supprimer" v-on:click="removeWorkshopSchedule"></sui-button>
        </sui-segment>

        <sui-modal v-model="isEditingInputFile">
            <sui-modal-header>{{ $t('workshopSchedule.form.inputFileModal.title') }}</sui-modal-header>
            <sui-modal-content>
                <sui-form>
                    <sui-header dividing>{{ $t('workshopSchedule.form.inputFileModal.addInputFileTitle') }}</sui-header>

                    <sui-form-field>
                        <label>{{ $t('workshopSchedule.form.type') }}</label>
                        <input type="text" :value="workshopSchedule.type" disabled>
                    </sui-form-field>

                    <sui-form-field>
                        <label>{{ $t('workshopSchedule.form.inputFileModal.fileNameWithExtension') }}</label>
                        <div class="ui action input">
                            <input type="text" v-model="newInputFileName">
                            <sui-button
                                type="button"
                                :disabled="!newInputFileName"
                                v-on:click="addInputFile()"
                            >
                                {{ $t('workshopSchedule.form.inputFileModal.add') }}
                            </sui-button>
                        </div>
                    </sui-form-field>
                </sui-form>

                <sui-divider></sui-divider>

                <sui-form>
                    <sui-header dividing>{{ $t('workshopSchedule.form.inputFileModal.removeInputFileTitle') }}</sui-header>
                    <sui-form-field>
                        <label>{{ $t('workshopSchedule.form.inputFile') }}</label>
                        <div class="ui action input">
                            <sui-dropdown
                                :placeholder="$t('workshopSchedule.form.inputFile')"
                                selection
                                class="fluid"
                                :options="inputFileOptions"
                                v-model="selectedInputFileToRemove"
                            />
                            <sui-button
                                class="red"
                                type="button"
                                :disabled="!selectedInputFileToRemove"
                                v-on:click="removeInputFile"
                            >
                                {{ $t('workshopSchedule.form.inputFileModal.remove') }}
                            </sui-button>
                        </div>
                    </sui-form-field>
                </sui-form>
            </sui-modal-content>
            <sui-modal-actions>
                <sui-button v-on:click="handleInputFileModalState(false)">
                    {{ $t('common.cancel') }}
                </sui-button>
            </sui-modal-actions>
        </sui-modal>
    </sui-segment>
</template>

<script>
import { api } from '@/api';
import store from '@/store';

export default {
    name: 'CustomerWorkshopScheduleForm',
    data() {
        return {
            isLoading: false,
            isSaving: false,
            isEdit: !!this.$route.params.workshop_schedule_id,
            isEditingInputFile: false,
            canLoadMoreLines: true,

            types: [],
            templates: [],
            inputFiles: [],
            outputLines: [],

            customer: {},
            workshopSchedule: {
                id: null,
                name: null,
                type: null,
                customer_id: this.$route.params.customer_id,
                template_id: null,
                input_file_id: null,
                icar_filters: [],
            },

            selectedInputFileToRemove: null,
            newInputFileName: null,

            outputLinesOffset: 1,
        }
    },
    beforeDestroy() {
        store.commit('removeAppTitle');
    },
    async created() {
        this.isLoading = true;
        await Promise.all([
            this.getCustomer(),
            this.getTypes(),
            this.getTemplates(),
            this.getInputFiles(),
        ]);
        
        await this.getFormData(),

        store.commit('setAppTitle', `${this.$t('workshopSchedule.form.title')} - ${this.customer.name}`);

        this.isLoading = false;
    },
    methods: {
        async getFormData() {
            if (this.isEdit) {
                this.workshopSchedule = await api.workshopSchedules.getById(
                    this.$route.params.customer_id,
                    this.$route.params.workshop_schedule_id,
                );

                await this.getOutputLines();
            }
        },

        async getCustomer() {
            this.customer = await api.customers.getById(this.$route.params.customer_id);
        },

        async getTypes() {
            this.types = await api.workshopSchedules.getTypes();
        },

        async getTemplates() {
            this.templates = await api.workshopSchedules.getTemplates(this.$route.params.customer_id);
        },

        async getInputFiles() {
            this.inputFiles = await api.workshopSchedules.getInputFiles();
        },

        async getOutputLines() {
            const outputLines = await api.workshopSchedules.getOutputLines(
                this.workshopSchedule.input_file_id,
                this.outputLinesOffset
            );

            this.outputLines.push(...outputLines);
            this.outputLinesOffset++;

            this.canLoadMoreLines = outputLines.length > 0;

            return outputLines;
        },

        async addInputFile() {
            try {
                await api.workshopSchedules.addInputFile(this.newInputFileName, this.workshopSchedule.type);
                await this.getInputFiles();
                this.isEditingInputFile = false;

                this.$toastr.s(this.$t('workshopSchedule.form.inputFileModal.saveSuccess'));
            } catch (error) {
                this.$toastr.e(this.$t('workshopSchedule.form.anErrorOccured', { error: error.message }));
            }
        },

        async removeInputFile() {
            try {
                await api.workshopSchedules.removeInputFile(this.selectedInputFileToRemove);
                await this.getInputFiles();            
                this.isEditingInputFile = false;

                this.$toastr.s(this.$t('workshopSchedule.form.removeSuccess'));
            } catch (error) {
                this.$toastr.e(this.$t('workshopSchedule.form.anErrorOccured', { error: error.message }));
            }
        },

        async removeWorkshopSchedule() {
            try {
                await api.workshopSchedules.removeWorkshopSchedule(
                    this.workshopSchedule.customer_id,
                    this.workshopSchedule.id,
                );
                this.$toastr.s(this.$t('workshopSchedule.form.inputFileModal.removeSuccess'));
                this.$router.push({ name: 'CustomerWorkshopScheduleList' });
            } catch (error) {
                this.$toastr.e(this.$t('workshopSchedule.form.anErrorOccured', { error: error.message }));
            }
        },

        async onSaveWorkshopSchedule(e) {
            e.preventDefault();
            this.isSaving = true;

            try {
                this.workshopSchedule = await api.workshopSchedules.saveWorkshopSchedule(
                    this.workshopSchedule,
                    this.workshopSchedule.customer_id,
                    this.workshopSchedule.id,
                );

                this.isEdit = true;

                this.$toastr.s(this.$t('workshopSchedule.form.saveSuccess'));
            } catch (error) {
                this.$toastr.e(this.$t('workshopSchedule.form.anErrorOccured', { error: error.message }));
            } finally {
                this.isSaving = false;
            }
        },

        onTypeChange() {
            this.workshopSchedule.input_file_id = null;

            if (this.workshopSchedule.type === 'DATAFIRST') {
                this.workshopSchedule.icar_filters = [];
            }
        },

        async onInputFileChange() {
            this.outputLines = [];
            this.outputLinesOffset = 1;
            await this.getOutputLines();
        },

        addICarFilter() {
            this.workshopSchedule.icar_filters.push({
                id: Math.random().toString().replace('.', ''),
                company_code: null,
                workshop_code: null,
                section_code: null,
                receiver: null,
            });
        },

        removeICarFilter(id) {    
            const idx = this.workshopSchedule.icar_filters.findIndex(icar => icar.id === id);

            if (idx > -1) {
                this.workshopSchedule.icar_filters.splice(idx, 1);
            }
        },

        handleInputFileModalState(isEditingInputFile) {
            this.selectedInputFileToRemove = null;
            this.newInputFileName = null;

            this.isEditingInputFile = isEditingInputFile;
        }
    },
    computed: {
        typeOptions() {
            return this.types.map(t => ({ value: t.id, text: t.id }));
        },
        templateOptions() {
            return this.templates.map(t => ({ value: t.id, text: t.name }));
        },
        inputFileOptions() {
            return this.inputFiles
                .filter(i => i.type === this.workshopSchedule.type)
                .map(i => ({ value: i.id, text: i.name }));
        },
        companyCodeOptions() {
            const options = [];

            for (const outputLine of this.outputLines) {
                if (options.findIndex(option => option.value === outputLine.company_code) === -1) {
                    options.push({
                        value: outputLine.company_code,
                        text:outputLine.company_code,
                    });
                }
            }
            
            return options;
        },
        workshopCodeOptions() {
            const options = [];

            for (const outputLine of this.outputLines) {
                if (options.findIndex(option => option.value === outputLine.workshop_code) === -1) {
                    options.push({
                        value: outputLine.workshop_code,
                        text:outputLine.workshop_code,
                    });
                }
            }
            
            return options;
        },
        sectionCodeOptions() {
            const options = [];

            for (const outputLine of this.outputLines) {
                if (options.findIndex(option => option.value === outputLine.section_code) === -1) {
                    options.push({
                        value: outputLine.section_code,
                        text:outputLine.section_code,
                    });
                }
            }
            
            return options;
        },
        receiverOptions() {
            const options = [];

            for (const outputLine of this.outputLines) {
                if (options.findIndex(option => option.value === outputLine.receiver) === -1) {
                    options.push({
                        value: outputLine.receiver,
                        text:outputLine.receiver,
                    });
                }
            }
            
            return options;
        }
    }
}
</script>